
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bridge-loans",
      function () {
        return require("private-next-pages/bridge-loans.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bridge-loans"])
      });
    }
  